import type { ChipProps } from "@/types/component";

import { ApprovalRequestStatus, ApprovalStepStatus } from "../types/approval-flows.types";

/**
 * Durum -> Chip görünümü eşlemeleri.
 *
 * Bileşen dosyalarından değil buradan export edilir: React Fast Refresh, bir
 * dosyadan bileşen dışı değer export edildiğinde o modülü sıcak
 * güncelleyemiyor ("export is incompatible") ve tüm sayfayı yeniliyor.
 */
export const REQUEST_STATUS_CHIP: Record<
  ApprovalRequestStatus,
  { type: ChipProps["type"]; label: string }
> = {
  [ApprovalRequestStatus.PENDING]: { type: "info", label: "Bekliyor" },
  [ApprovalRequestStatus.APPROVED]: { type: "success", label: "Onaylandı" },
  [ApprovalRequestStatus.REJECTED]: { type: "error", label: "Reddedildi" },
  [ApprovalRequestStatus.CANCELLED]: { type: "default", label: "İptal" },
};

export const STEP_STATUS_CHIP: Record<
  ApprovalStepStatus,
  { type: ChipProps["type"]; label: string }
> = {
  [ApprovalStepStatus.PENDING]: { type: "default", label: "Bekliyor" },
  [ApprovalStepStatus.APPROVED]: { type: "success", label: "Onaylandı" },
  [ApprovalStepStatus.REJECTED]: { type: "error", label: "Reddedildi" },
  [ApprovalStepStatus.SKIPPED]: { type: "default", label: "Atlandı" },
};
